var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CommonAttributes } from "./Common/Constants";
import { dismissDependencyPageNotification, transitToReadyToSend } from "./LifecycleActions";
var LifecycleEventHandler = /** @class */ (function () {
    function LifecycleEventHandler(entityDescriptor, prePublishValidate, logFunctionalEvent, waitForChanges) {
        if (logFunctionalEvent === void 0) { logFunctionalEvent = function () { }; }
        if (waitForChanges === void 0) { waitForChanges = function () { return Promise.resolve(); }; }
        this.entityDescriptor = entityDescriptor;
        this.prePublishValidate = prePublishValidate;
        this.logFunctionalEvent = logFunctionalEvent;
        this.waitForChanges = waitForChanges;
    }
    LifecycleEventHandler.prototype.handleSaveEvent = function (context) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var eventArgs, isSaveModalOpen, statuscode, formContext_1, valid;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        eventArgs = context.getEventArgs();
                        isSaveModalOpen = !!parent.document.querySelector('[id*="modalDialogContentContainer"]');
                        if (eventArgs.getSaveMode() === 70 /* Xrm.Constants.SaveMode.AutoSave */ ||
                            (!isSaveModalOpen && eventArgs.getSaveMode() === 2 /* Xrm.Constants.SaveMode.SaveAndClose */)) {
                            eventArgs.preventDefault();
                            return [2 /*return*/];
                        }
                        this.logFunctionalEvent("Saving");
                        dismissDependencyPageNotification();
                        statuscode = (_a = context.getFormContext().getAttribute(CommonAttributes.status)) === null || _a === void 0 ? void 0 : _a.getValue();
                        if (!(statuscode === this.entityDescriptor.liveEditingStatusCode)) return [3 /*break*/, 3];
                        eventArgs.preventDefault();
                        return [4 /*yield*/, this.waitForChanges()];
                    case 1:
                        _b.sent();
                        formContext_1 = context.getFormContext();
                        return [4 /*yield*/, this.prePublishValidate(formContext_1)];
                    case 2:
                        valid = _b.sent();
                        if (valid) {
                            this.logFunctionalEvent("SaveValid");
                            // If the original promise for validaiton succeeds synchronously a call to XRM data save will fail
                            // as XRM does not allow recursive save calls. setTimeout is called to ensure the current call finishes successfully.
                            setTimeout(function () {
                                transitToReadyToSend(formContext_1, _this.entityDescriptor, function () { return _this.logFunctionalEvent("SaveDone"); });
                            }, 1);
                        }
                        else {
                            this.logFunctionalEvent("SaveNotValid");
                        }
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.waitForChanges()];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LifecycleEventHandler.prototype.handlePostSaveEvent = function (context) {
        var _a, _b;
        var isSaveSuccess = (_b = (_a = context.getEventArgs()) === null || _a === void 0 ? void 0 : _a.getIsSaveSuccess) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (isSaveSuccess) {
            this.logFunctionalEvent("SaveDone");
        }
    };
    return LifecycleEventHandler;
}());
export { LifecycleEventHandler };
